module.exports = __webpack_public_path__ + "img/sc.0abc8a95.png";